angular.module('impactx.polling', []);